export default {"src":"https://cdn2.e-farm.com/website-static/_next/static/media/da.b9c6741f.svg","height":280,"width":370,"blurWidth":0,"blurHeight":0};